import { List } from 'components/ui';
import ListItem from 'components/inspection_subject/index/list_item';
import ListHeader from 'components/inspection_subject/index/list_header';
import Loader from 'components/loader';

const Index = ({ inspectionSubjects, sortBy, onSortChange, loading }) => {
  if (loading) return <Loader />;

  return (
    <List>
      <ListHeader
        visible={inspectionSubjects.inspectionSubjects.length > 0}
        sortBy={sortBy}
        onSortChange={onSortChange}
      />
      {inspectionSubjects.inspectionSubjects.map((inspectionSubject) => (
        <ListItem key={inspectionSubject.id} inspectionSubject={inspectionSubject} />
      ))}
    </List>
  );
};

export default Index;
